export const SCORE_WHITELIST = Object.freeze([
    'jooycar@fleetr.com',
    'maganaluis2002@gmail.com',
    'demoadmin@fleetr.com',
    'demouser@fleetr.com',
    'adam.murphy@marshmma.com',
    'stuart.taylor@marshmma.com',
    'rachel.sladin@marshmma.com',
    'bill.kassal@marshmma.com',
    'russell.hoffman@marshmma.com'
])


export const UPSELLING_WHITELIST = Object.freeze([
    'elopez@fleetr.app',
    'jooycar@fleetr.com',
    'maganaluis2002@gmail.com',
    'matt@fleetr.app',
])
